module.exports = __webpack_public_path__ + "media/images/noimage-38f5cc7769a16390269d48ad31483472.gif";